import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/shared/auth/AuthProvider";
import { PublicConfigForegroundRefresh } from "@/shared/api/PublicConfigForegroundRefresh";
import { VerifyLinkProvider } from "@/shared/auth/VerifyLinkOverlay";
import { ThemeProvider } from "@/shared/theme/ThemeProvider";
import { router } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <PublicConfigForegroundRefresh />
      <ThemeProvider>
        <AuthProvider>
          <VerifyLinkProvider>
            <RouterProvider router={router} />
          </VerifyLinkProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
